// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1676":"c3a71a48","1729":"9ba70dc1","2155":"aac3e6ba"}[chunkId] + ".chunk.css";
};